import { Wrench } from 'lucide-react';

export interface MaintenanceScreenProps {
  title?: string | null;
  message?: string | null;
  endsAt?: string | null;
}

const formatEndsAt = (endsAt: string): string | null => {
  const date = new Date(endsAt);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('es-AR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export function MaintenanceScreen({
  title,
  message,
  endsAt,
}: MaintenanceScreenProps) {
  const formattedEndsAt = endsAt ? formatEndsAt(endsAt) : null;

  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2 px-6 text-center">
        <Wrench className="h-20 w-20 text-muted-foreground mb-2" />
        <h1 className="text-[7rem] leading-tight font-bold">503</h1>
        <span className="font-medium text-lg">
          {title || 'Estamos en mantenimiento'}
        </span>
        <p className="text-muted-foreground">
          {message ||
            'El sitio no está disponible en este momento. Volveremos en línea muy pronto.'}
        </p>
        {formattedEndsAt && (
          <p className="text-muted-foreground text-sm mt-2">
            Estimamos volver: {formattedEndsAt}
          </p>
        )}
      </div>
    </div>
  );
}
